import type { UserColleague } from './user-colleagues.model';

export interface GenerateUserColleagueOptions {
  /** The id of the user who is a colleague (shares the logged-in user's email domain). */
  readonly id: number;
}

export function generateUserColleagueObject({
  id,
}: GenerateUserColleagueOptions): UserColleague {
  return { id };
}
